import { addDays, format, startOfDay } from 'date-fns'

import { SLIDES } from './consts'

export function today() {
  return startOfDay(new Date())
}

export function currentYear() {
  const today = new Date()

  return today.getFullYear()
}

export function maxEndDate() {
  return addDays(today(), 180)
}

export function tomorrow() {
  return addDays(today(), 1)
}

export function combineSlidesValues(slides) {
  return new Array(2 ** slides.length)
    .fill(null)
    .map((value, index) =>
      index
        .toString(2)
        .padStart(slides.length, '0')
        .split('')
        .map((digit) => !!+digit),
    )
    .sort(
      (configA, configB) =>
        configB.filter((value) => !value).length -
          configA.filter((value) => !value).length ||
        configA.findIndex((value, index) => value && !configB[index]) -
          configB.findIndex((value, index) => value && !configA[index]),
    )
    .map((value) => {
      const config = value.reduce((config, value, index) => {
        config[slides[index]] = value

        return config
      }, {})

      return buildSlidesValue(config)
    })
}

export function buildSlidesValue(slides) {
  return [
    slides.driver ? SLIDES.DRIVER : '',
    slides.passenger ? SLIDES.PASSENGER : '',
    slides.rear ? SLIDES.REAR : '',
  ]
    .filter((slide) => !!slide)
    .join('-')
}

export function parseSlidesConfig(slidesValue) {
  const slides = new Set(slidesValue.split('-'))

  return {
    driver: slides.has(SLIDES.DRIVER),
    passenger: slides.has(SLIDES.PASSENGER),
    rear: slides.has(SLIDES.REAR),
  }
}

export function buildAvailabilityQuery(values) {
  const {
    reservationDates: { from, to },
    adults,
    children,
    infants,
    pets,
    rvSlides,
    rvLength,
    unitType,
    siteType,
    equipmentType,
    manufactureYear,
    ...vehicle
  } = values

  if (manufactureYear) {
    vehicle.manufactureYear = +manufactureYear
  }

  return {
    from: format(from, 'yyyy-MM-dd'),
    to: format(to, 'yyyy-MM-dd'),
    guests: { adults, children, infants, pets },
    unitType,
    siteType,
    vehicle: {
      equipmentType,
      length: rvLength,
      slides: parseSlidesConfig(rvSlides),
      ...vehicle,
    },
  }
}
